<template>
	<div class="Item">
		<headerItemDv1 msg="白名单授信列表"></headerItemDv1>
		<div class="grid-container">
            <dv-scroll-board class="f-28" :config="config" :waitTime="1000000" style="width: 100%; height: 400px; font-size: 28px;" />
        </div>
	</div>
</template>
<script>
import headerItemDv1 from '@/components/headerItemDv1.vue';
export default {
	name: '',
	components: {
		headerItemDv1
	},
	props: {
		current: Number,
	},
	watch: {
		current(newVal, oldVal) {
			if (newVal === 1) {
				this.config = this.config1
			} else if (newVal === 0) {
				this.config = this.config0
			}
		}
	},
	data() {
		return {
            config: {},
            config0: {
                header: ['客户姓名', '所属村居', '客户经理', '授信额度', '年利率'],
                headerBGC: 'rgba(13, 15, 20, 1)',
                data: [
					['张**', "丁**", 'ding-客户经理', "<span style='color: green'>200000元</span>", "<span style='color: red'>10%</span>"],
					['张**', "丁**", 'ding-客户经理', "<span style='color: green'>200000元</span>", "<span style='color: red'>7%</span>"],
					['王**', "丁**", 'ding-客户经理', "<span style='color: green'>100000元</span>", "<span style='color: red'>7%</span>"],
					['小**', "丁**", 'ding-客户经理', "<span style='color: green'>100000元</span>", "<span style='color: red'>7%</span>"],
					['丁**', "丁**", 'ding-客户经理', "<span style='color: green'>100000元</span>", "<span style='color: red'>7%</span>"],
					['李**', "丁**", '客户经理-测试', "<span style='color: green'>500000元</span>", "<span style='color: red'>7%</span>"],
					['人**', "丁**", '客户经理康巴什', "<span style='color: green'>900000元</span>", "<span style='color: red'>9%</span>"],
					['魏**', "丁**", '客户经理康巴什', "<span style='color: green'>900000元</span>", "<span style='color: red'>10%</span>"],
					['海**', "丁**", '客户经理康巴什', "<span style='color: green'>000000元</span>", "<span style='color: red'>10%</span>"],
					['乌**', "丁**", 'ding-客户经理', "<span style='color: green'>200000元</span>", "<span style='color: red'>8%</span>"],
                ],
                oddRowBGC: 'transparent',
                evenRowBGC: 'rgba(9, 36, 103, .7)',
                index: true,
				headerHeight: 100,
                // columnWidth: [50],
                align: ['center']
            },
			config1: {
                header: ['客户姓名', '所属村居', '客户经理', '授信额度', '年利率'],
                headerBGC: 'rgba(13, 15, 20, 1)',
                data: [
					['小**', "丁**", 'ding-**', "<span style='color: green'>100000元</span>", "<span style='color: red'>10%</span>"],
					['小**', "丁**", 'ding-**理', "<span style='color: green'>100000元</span>", "<span style='color: red'>7%</span>"],
					['小**', "丁**", 'ding-**', "<span style='color: green'>100000元</span>", "<span style='color: red'>7%</span>"],
					['小**', "丁**", 'ding-**', "<span style='color: green'>200000元</span>", "<span style='color: red'>7%</span>"],
					['小**', "丁**", 'ding-**', "<span style='color: green'>00000元</span>", "<span style='color: red'>7%</span>"],
					['李**', "回**", '客**', "<span style='color: green'>100000元</span>", "<span style='color: red'>7%</span>"],
					['人**', "新**", '客**', "<span style='color: green'>80000元</span>", "<span style='color: red'>9%</span>"],
					['一**', "新**", '客**', "<span style='color: green'>70000元</span>", "<span style='color: red'>10%</span>"],
					['星**1', "新**", '客**', "<span style='color: green'>100000元</span>", "<span style='color: red'>10%</span>"],
					['李**', "哈**", 'd-**', "<span style='color: green'>200000元</span>", "<span style='color: red'>8%</span>"],
                ],
                oddRowBGC: 'transparent',
                evenRowBGC: 'rgba(9, 36, 103, .7)',
                index: true,
				headerHeight: 100,
                // columnWidth: [50],
                align: ['center']
            }
		}
	},
	mounted() {
        this.config = this.config0
	},
	methods: {
	}
}
</script>
<style lang="less" scoped>
.Item {
    font-size: 28px !important;
	.grid-container {
		width: 100%;
		display: grid;
		grid-template-columns: 1fr;
		/* 这表示列的大小为1fr */
		grid-template-rows: 1fr;
		/* 这表示行的大小为1fr */
		justify-items: center;

		.grid-item {
			box-sizing: border-box;
			border: 1px solid #e4e4e4;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
			text-align: center;
			padding: 20px;
		}
        .custom-font /deep/ .board-item {
            font-size: 10px;
        }
		.dv-scroll-board .header{
			font-size: 28px;
		}
	}
}

</style>
